<template>
  <div class="member-invite-enter-code">
    <member-already-exists-error v-if="memberAlreadyExists" :phone-number="phoneNumber" />
    <enter-code v-else :first-name="firstName"
                      :phone-number="phoneNumber"
                      :confirm-code-action="createMemberAndProceed"
                      :regenerate-code-action="generateCode"
                      :server-error="errors.createMember"
                      :button-title="'אישור'"
                      :loading="loading"
                      :reset-error="() => resetError('createMember')"/>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import Segment from '../../../../../Segment';
import EnterCode from '../../../../../base-components/EnterCode.vue';
import MemberAlreadyExistsError from '../../../../general-errors/MemberAlreadyExistsError.vue';

export default {
  name: 'MemberInviteEnterCode',
  components: {
    EnterCode,
    MemberAlreadyExistsError,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('MemberInviteEnterCodeEntered');
  },
  computed: {
    ...mapState('memberInvite', ['firstName', 'lastName', 'phoneNumber', 'errors']),
    ...mapGetters('memberInvite', ['inviteMemberFlowSteps', 'errorTypes']),
    memberAlreadyExists() {
      return this.errors.createMember === this.errorTypes.memberAlreadyExists;
    },
  },
  methods: {
    ...mapMutations('memberInvite', ['resetError']),
    ...mapActions('memberInvite', ['createMember', 'generateCode']),
    async createMemberAndProceed(code) {
      try {
        this.loading = true;
        await this.createMember(code);
        this.next();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '../../../../../scss/mixins';

  .member-invite-enter-code {
    margin: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/invite-authenticated/member-invite/pages/MemberInviteEnterCode.vue